import React from 'react';
import {
    List, Edit, Create, Delete,
    DateField, BooleanField, BooleanInput, DeleteButton,
    Datagrid, TextField, EditButton, DisabledInput,
    NumberField, SimpleForm, TextInput, NumberInput
} from 'admin-on-rest';

export const GetProxyServers = (props) => (
    <List {...props}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="host" />
            <NumberField source="port" />
            <TextField source="user" />
            <TextField source="password" />
            <DateField source="died_at" />
            <EditButton />
        </Datagrid>
    </List>
);

export const CreateProxyServer = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="host" required />
            <NumberInput source="port" required />
            <TextInput source="user" />
            <TextInput source="password" />
        </SimpleForm>
    </Create>
);

const ProxyServerTitle = ({ record }) => {
    return <span>Edit {record ? `"${record.host}"` : ''}</span>;
};

export const EditProxyServer = (props) => (
    <Edit title={<ProxyServerTitle />} {...props}>
        <SimpleForm>
            <DisabledInput source="id" />
            <TextInput source="host" required />
            <NumberInput source="port" required />
            <TextInput source="user" />
            <TextInput source="password" />
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/proxyserver.js